import { useQuery } from '@apollo/client';

import MaintenancesTable from '../../components/admin/MaintenancesTable';
import ErrorText from '../../components/ErrorText';
import Button from '../../components/inputs/Button';
import LoadingSpinner from '../../components/LoadingSpinner';
import { MAINTENANCES_QUERY } from '../../queries';
import { useActionModal } from '../../hooks/useActionModal';
import { START_ACTION } from '../../reducers/actionReducer';
import ScheduleMaintenance from '../../components/actions/ScheduleMaintenance';

export default function AdminMaintenance() {
  const { loading, error, data } = useQuery(MAINTENANCES_QUERY);
  const maintenances = data?.maintenances;

  const { dispatch: dispatchAction } = useActionModal();

  function handleScheduleMaintenanceClick() {
    dispatchAction({
      type: START_ACTION,
      payload: {
        name: 'Schedule Maintenance',
        component: <ScheduleMaintenance dispatchAction={dispatchAction} />,
        isReactHookForm: true,
      },
    });
  }

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-row justify-end">
        <Button
          type="button"
          primary
          small
          className="my-4"
          onClick={handleScheduleMaintenanceClick}
        >
          Schedule Maintenance
        </Button>
      </div>
      <div className="w-full">
        {loading && <LoadingSpinner message="Loading Maintenance records..." />}
        {error && <ErrorText className="mt-2" message={error.message} />}
        {maintenances && maintenances?.length > 0 && (
          <MaintenancesTable maintenances={maintenances} />
        )}
        {maintenances?.length === 0 && <p>No scheduled maintenance.</p>}
      </div>
    </div>
  );
}
